import { get, post } from './request'
import { utilities } from '@billow/js-helpers'

export let list = (success, failure) => {
  return get(
    `api/facility/list`, success, failure
  )
}

export let paginate = (path, success, failure) => {
  return get (
    `api${path}`, success, failure
  )
}

export let create = (facility, success, failure) => post(
  `api/facility/create`, facility, success, failure
)

export let load = (facility, success, failure) => get(
  `api/facility/${facility}`, success, failure
)

export let save = (facility, success, failure) => post(
  `api/facility/${facility.id}/update`, facility, success, failure
)

export let saveFile = (payload, success, failure) => {

  return post(
    `api/facility/${payload.facilityId}/file/update`,
    utilities.formData(payload),
    success,
    failure
  )
}

export let newPrice = (payload, success, failure) => post(
  `api/facility/${payload.facility}/pricing/new`, payload, success, failure
)

export let savePrice = (pricing, success, failure) => post(
  `api/facility/pricing/${pricing.id}/update`, pricing, success, failure
)

export let removePricing = (pricing, success, failure) => post(
  `api/facility/pricing/${pricing}/remove`, {}, success, failure
)

export let newExtra = ({ facility, extra }, success, failure) => post(
  `api/facility/${facility}/extra/new`, extra, success, failure
)

export let saveExtra = (extra, success, failure) => post(
  `api/facility/extra/${extra.id}/update`, extra, success, failure
)

export let removeExtra = (extra, success, failure) => post(
  `api/facility/extra/${extra}/remove`, {}, success, failure
)